// extracted by mini-css-extract-plugin
export default {"page":"layout_page__fsaUw","mainWrapper":"layout_mainWrapper__4EkWg","contentWrapper":"layout_contentWrapper__fZ3Dr","footer":"layout_footer__AfYg+"};